import SearchLocationInput from "../components/SearchLocationInput";
import React, {useState} from "react";
import {numberFormat} from "../Assets/StaticContents/helpers";

const CalculateTripCost = () => {
    const [pickupQuery, setPickupQuery] = useState("");
    const [destinationQuery, setDestinationQuery] = useState("")
    const [seat, setSeat] = useState(1)
    const [tripCost, setTripCost] = useState(0)
    const resetForm = () => {
        setPickupQuery("")
        setDestinationQuery("")
        setSeat(1)
        setTripCost(0)
    }
    const calculateDistance = () => {
        if (window.google){
            const service = new window.google.maps.DistanceMatrixService()
            service.getDistanceMatrix(
                {
                    origins: [pickupQuery],
                    destinations: [destinationQuery],
                    travelMode: window.google.maps.TravelMode.DRIVING,
                    avoidHighways: false,
                    avoidTolls: false
                },
                (response, status) => {
                    if(status === "OK" ) {
                        if (response.rows[0].elements[0].status !== "ZERO_RESULTS"){
                            const distance = response.rows[0].elements[0].distance.value;
                            const amount = 150 + 0.050 * distance
                            setTripCost(amount)
                        }
                        else {
                            alert("Error: " + response.rows[0].elements[0].status)
                        }
                    } else {
                        alert("Error: " + status);
                    }
                })
        }
    }
    const calculateCost = () => {
        if (destinationQuery && pickupQuery && seat){
            calculateDistance()
        }
    }

    const seatUpdate = (e) => {
        e.persist()
        setSeat(e.target.value)
        setTripCost(0)
    }

    return (
        <div className="px-0 pl-3 md:pl-0 pr-3 md:pr-6 py-12">
            <h2 className="px-1 text-md font-semibold pb-4">Know your trip cost.</h2>
            <form action="#" className="">
                <div className="w-full">
                    <div className="w-full px-1 py-2">
                        <label className="mb-2 text-gray-700 text-sm">
                            Pick up point
                            <span className="text-red-500">*</span>
                        </label>
                        <div className="relative border border-green-500 mt-2 rounded">
                            <p className="py-1 top-1.5 left-3 absolute h-full">
                                <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 0.5C2.85 0.5 0 2.915 0 6.65C0 9.035 1.8375 11.84 5.505 15.0725C5.79 15.32 6.2175 15.32 6.5025 15.0725C10.1625 11.84 12 9.035 12 6.65C12 2.915 9.15 0.5 6 0.5ZM6 8C5.175 8 4.5 7.325 4.5 6.5C4.5 5.675 5.175 5 6 5C6.825 5 7.5 5.675 7.5 6.5C7.5 7.325 6.825 8 6 8Z" fill="#8ACC74"/></svg>
                            </p>
                            <SearchLocationInput
                                query={pickupQuery}
                                setQuery={setPickupQuery}
                            />
                        </div>
                    </div>
                    <div className="w-full px-1 py-2">
                        <label className="mb-2 text-gray-700 text-sm">
                            Destination point
                            <span className="text-red-500">*</span>
                        </label>
                        <div className="relative border border-green-500 mt-2 rounded">
                            <p className="py-1 top-1.5 left-3 absolute h-full">
                                <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 0.5C2.85 0.5 0 2.915 0 6.65C0 9.035 1.8375 11.84 5.505 15.0725C5.79 15.32 6.2175 15.32 6.5025 15.0725C10.1625 11.84 12 9.035 12 6.65C12 2.915 9.15 0.5 6 0.5ZM6 8C5.175 8 4.5 7.325 4.5 6.5C4.5 5.675 5.175 5 6 5C6.825 5 7.5 5.675 7.5 6.5C7.5 7.325 6.825 8 6 8Z" fill="#8ACC74"/></svg>
                            </p>
                            <SearchLocationInput
                                query={destinationQuery}
                                setQuery={setDestinationQuery}
                            />
                        </div>
                    </div>
                    <div className="w-full px-1 py-2">
                        <label className="mb-2 text-gray-700 text-sm">
                            Number of seats required
                            <span className="text-red-500">*</span>
                        </label>
                        <div className="relative border border-green-500 mt-2 rounded">
                            <p className="py-1 top-1.5 left-2 absolute h-full">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fillRule="evenodd" clipRule="evenodd" d="M12.5024 9.8475C13.5299 10.545 14.2499 11.49 14.2499 12.75V15H16.4999C16.9124 15 17.2499 14.6625 17.2499 14.25V12.75C17.2499 11.115 14.5724 10.1475 12.5024 9.8475Z" fill="#002500"/> <path d="M6.75 9C8.40686 9 9.75 7.65685 9.75 6C9.75 4.34315 8.40686 3 6.75 3C5.09315 3 3.75 4.34315 3.75 6C3.75 7.65685 5.09315 9 6.75 9Z" fill="#002500"/> <path fillRule="evenodd" clipRule="evenodd" d="M11.2499 9C12.9074 9 14.2499 7.6575 14.2499 6C14.2499 4.3425 12.9074 3 11.2499 3C10.8974 3 10.5674 3.075 10.2524 3.18C10.8749 3.9525 11.2499 4.935 11.2499 6C11.2499 7.065 10.8749 8.0475 10.2524 8.82C10.5674 8.925 10.8974 9 11.2499 9Z" fill="#002500"/> <path fillRule="evenodd" clipRule="evenodd" d="M6.75 9.75C4.7475 9.75 0.75 10.755 0.75 12.75V14.25C0.75 14.6625 1.0875 15 1.5 15H12C12.4125 15 12.75 14.6625 12.75 14.25V12.75C12.75 10.755 8.7525 9.75 6.75 9.75Z" fill="#002500"/> </svg>
                            </p>
                            <select name="seat"
                                    value={seat}
                                    onChange={seatUpdate}
                                    className="block w-full rounded py-1.5 pl-8 px-2 focus:outline-none text-gray-700">
                                <option value={1}>1</option>
                                <option value={2}>2</option>
                                <option value={3}>3</option>
                            </select>
                        </div>
                    </div>
                    <div className="w-full px-2 py-3 space-y-2">
                        { tripCost === 0
                            ?
                            <button onClick={e => calculateCost(e)} type="button"
                                    style={{backgroundColor: 'rgba(138, 204, 116, 0.4)',}}
                                    className="w-full bg-green-200 border border-transparent rounded-sm py-2 px-4 flex items-center justify-center text-base font-bold text-green-500 focus:outline-none">
                                Calculate
                            </button>
                            :
                            <div type="button"
                                 style={{backgroundColor: 'rgba(138, 204, 116, 0.4)',}}
                                 className="w-full bg-green-200 border border-transparent rounded-sm py-2 px-4 flex items-center justify-center text-base font-bold text-green-500 focus:outline-none">
                                {numberFormat(tripCost * seat)}
                            </div>
                        }
                    </div>

                    <div className="w-full px-2 py-3 inline-flex justify-center">
                        <button type="reset" onClick={resetForm} className="text-sm underline font-semibold" style={{color: '#009933'}}>
                            Reset
                        </button>
                    </div>
                </div>
            </form>
        </div>
    )
}
// 150+0.050*distance
export default CalculateTripCost
